export const  EstatusDocumentoEnum  = Object.freeze({
    SIN_ESTATUS: 0,
    CANCELADO: 1,
    COBRADO: 2,
    TIMBRADO: 3,
    INACTIVO: 4,
    PAUSA: 5,
    CERRADO: 6
})